import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../Elements';

import classes from './Notification.module.scss';

const Notification = ({ text, onClose, loader }) => {
  return (
    <div className={classes.notification}>
      <p className={classes.text}>{text}</p>
      {loader && <Icon icon={'Icn_Loader'} className={classes.loaderNotif} />}
      <button type="button" onClick={onClose} className={classes.closeBtn}>
        <Icon icon={'Icn_Clear-3'} className={classes.close} />
      </button>
    </div>
  );
};

Notification.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  loader: PropTypes.bool
};

export default Notification;
